// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1kJei","left":"InfoRow_left__2JLsL"};